// These operations use the portal API token, not cross-origin browser cookies.
// The CMS allows wildcard CORS for this token-based public API.
export const publicNewsletterApiContext = {
  fetchOptions: {
    credentials: 'omit' as const,
    headers: { authorization: `Bearer ${process.env.NEXT_PUBLIC_CMS_API_TOKEN ?? ''}` },
  },
};

// The server reads the HttpOnly NextAuth session and forwards its user token.
export const newsletterPreferencesApiContext = { url: '/api/newsletter/preferences' };
